import { h } from 'preact';
import { useState } from 'preact/hooks';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Scrollbar } from 'swiper';

const ProductOffers = ({ data }) => {
  const [swiper, setSwiper] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [totalSlides, setTotalSlides] = useState(data.length);

  const handleSlideChange = () => {
    if (swiper) {
      setCurrentSlide(swiper.activeIndex);
    }
  };

  // Calculate progress percentage based on current slide and total slides
  const progressPercentage = ((currentSlide + 1) / totalSlides) * 100;

  const isFirstSlide = currentSlide === 0;
  const isLastSlide = currentSlide === totalSlides - 1;

  return (
    <div className="pdp-offers relative">
      {/* New header section */}
      <div className="flex justify-between items-center pb-2">
        <p className="text-lg font-medium">Offer{data.length > 1 ? 's' : ''}</p>
        {data.length > 1 && (
          <div className="flex items-center space-x-2">
            <div
              className={`!mx-0 h-[22px] text-gray-400 transform ${
                isFirstSlide ? 'opacity-30 cursor-not-allowed' : 'cursor-pointer'
              }`}
              onClick={() => !isFirstSlide && swiper?.slidePrev()}
              role="button"
              tabIndex={isFirstSlide ? -1 : 0}
              onKeyDown={(e) => {
                if (!isFirstSlide && (e.key === 'Enter' || e.key === ' ')) {
                  swiper?.slidePrev();
                }
              }}
            >
              <button type="button" className="left-arrow-button">
                <svg
                  className="rotate-180"
                  width="24"
                  height="25"
                  viewBox="0 0 24 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3 11.5C2.44772 11.5 2 11.9477 2 12.5C2 13.0523 2.44772 13.5 3 13.5V11.5ZM21.7071 13.2071C22.0976 12.8166 22.0976 12.1834 21.7071 11.7929L15.3431 5.42893C14.9526 5.03841 14.3195 5.03841 13.9289 5.42893C13.5384 5.81946 13.5384 6.45262 13.9289 6.84315L19.5858 12.5L13.9289 18.1569C13.5384 18.5474 13.5384 19.1805 13.9289 19.5711C14.3195 19.9616 14.9526 19.9616 15.3431 19.5711L21.7071 13.2071ZM3 13.5H21V11.5H3V13.5Z"
                    fill="black"
                  />
                </svg>
                <span className="hidden">Previous Offer</span>
              </button>
            </div>
            <span className="font-light !mx-[8px]">
              {currentSlide + 1}/{totalSlides}
            </span>
            <div
              className={`!mx-0 h-[22px] h-[20px] ${isLastSlide ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
              onClick={() => !isLastSlide && swiper?.slideNext()}
              role="button"
              tabIndex={isLastSlide ? -1 : 0}
              onKeyDown={(e) => {
                if (!isLastSlide && (e.key === 'Enter' || e.key === ' ')) {
                  swiper?.slideNext();
                }
              }}
            >
              <button type="button" className="right-arrow-button">
                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M3 11.5C2.44772 11.5 2 11.9477 2 12.5C2 13.0523 2.44772 13.5 3 13.5V11.5ZM21.7071 13.2071C22.0976 12.8166 22.0976 12.1834 21.7071 11.7929L15.3431 5.42893C14.9526 5.03841 14.3195 5.03841 13.9289 5.42893C13.5384 5.81946 13.5384 6.45262 13.9289 6.84315L19.5858 12.5L13.9289 18.1569C13.5384 18.5474 13.5384 19.1805 13.9289 19.5711C14.3195 19.9616 14.9526 19.9616 15.3431 19.5711L21.7071 13.2071ZM3 13.5H21V11.5H3V13.5Z"
                    fill="black"
                  />
                </svg>
                <span className="hidden">Next Offer</span>
              </button>
            </div>
          </div>
        )}
      </div>

      {data.length === 1 ? (
        <div className="pdp-offer-slide p-4 text-center bg-[#F9F6F1]">
          <p className="text-body-2 font-medium text-[#333333]">{data[0].title}</p>
          {data[0].link && data[0].link.url && data[0].link.text && (
            <p className="mt-[4px]">
              <a href={data[0].link.url} className="text-black font-normal underline">
                {data[0].link.text}
              </a>
            </p>
          )}
        </div>
      ) : (
        <Swiper
          modules={[Scrollbar]}
          scrollbar={{
            el: '[data-product-offers-scroll-bar]',
            draggable: true,
          }}
          navigation={{
            nextEl: '[data-product-offers-slide-next]',
            prevEl: '[data-product-offers-slide-prev]',
          }}
          onSwiper={(swiperInstance) => {
            setSwiper(swiperInstance);
            setTotalSlides(swiperInstance.slides.length);
          }}
          onSlideChange={handleSlideChange}
          className="pdp-offers-slider w-full"
          breakpoints={{
            0: {
              slidesPerView: 1,
              spaceBetween: 0,
            },
          }}
        >
          {data.map((item, index) => (
            <SwiperSlide key={index} className="pdp-offer-slide p-4 text-center bg-[#F9F6F1]">
              <p className="text-body-2 font-medium text-[#333333]">{item.title}</p>
              {item.link && item.link.url && item.link.text && (
                <p className="mt-[4px]">
                  <a href={item.link.url} className="text-black font-normal underline">
                    {item.link.text}
                  </a>
                </p>
              )}
            </SwiperSlide>
          ))}
        </Swiper>
      )}

      <div className="absolute bottom-0 left-0 w-full h-[2px] bg-[#e6e6e6] lg:flex hidden">
        {data.length > 1 && (
          <div
            className="h-full bg-black transition-all duration-300 ease-in-out z-[1] relative mt-[12px]"
            style={{ width: `${progressPercentage}%` }}
          ></div>
        )}
      </div>

      <div
        className="w-full h-[2.5px] mt-4 relative before:content-[''] before:absolute before:w-full before:h-[2.5px] before:left-0 before:top-0 before:bg-[#e6e6e6] lg:hidden"
        data-product-offers-scroll-bar
      ></div>
    </div>
  );
};

export default ProductOffers;
